import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/img/insurance/add.png'
import _imports_1 from '@/assets/img/insurance/renew.png'
import _imports_2 from '@/assets/img/insurance/reduce.png'
import _imports_3 from '@/assets/img/mp.png'


const _withScopeId = n => (_pushScopeId("data-v-5680fc61"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "block" }
const _hoisted_2 = {
  class: "block-search row",
  style: {"padding":"0"}
}
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "block-title" }, "加减记录", -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "line" }, null, -1))
const _hoisted_5 = { class: "block-content" }
const _hoisted_6 = { class: "table" }
const _hoisted_7 = {
  key: 0,
  class: "label add"
}
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: "",
  class: "label-icon"
}, null, -1))
const _hoisted_9 = {
  key: 1,
  class: "label reduce"
}
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  alt: "",
  class: "label-icon"
}, null, -1))
const _hoisted_11 = {
  key: 2,
  class: "label reduce"
}
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_2,
  alt: "",
  class: "label-icon"
}, null, -1))
const _hoisted_13 = { style: {"display":"flex"} }
const _hoisted_14 = ["src"]
const _hoisted_15 = {
  key: 1,
  src: _imports_3,
  alt: ""
}
const _hoisted_16 = ["onClick"]
const _hoisted_17 = /*#__PURE__*/_createTextVNode(" | ")
const _hoisted_18 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_date_picker = _resolveComponent("el-date-picker")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_pagination = _resolveComponent("el-pagination")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createVNode(_component_el_date_picker, {
        modelValue: _ctx.slotdate,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.slotdate) = $event)),
        type: "daterange",
        onChange: _ctx.handleCurrentChange,
        class: "date-month",
        "value-format": "YYYY-MM-DD",
        style: {"width":"260px"}
      }, null, 8, ["modelValue", "onChange"])
    ]),
    _hoisted_4,
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("div", _hoisted_6, [
        _createVNode(_component_el_table, {
          data: _ctx.tableData,
          style: {"width":"100%"},
          "max-height": "500",
          "header-cell-class-name": "table-head",
          "row-style": { color: '#5E617D', height: '30px' },
          "cell-style": {padding: '3px 0px' }
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_table_column, {
              prop: "type",
              width: "90",
              label: "操作类型"
            }, {
              default: _withCtx((scope) => [
                (scope.row.type === '加保')
                  ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                      _hoisted_8,
                      _createTextVNode(" " + _toDisplayString(scope.row.type), 1)
                    ]))
                  : (scope.row.type === '续保')
                    ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                        _hoisted_10,
                        _createTextVNode(" " + _toDisplayString(scope.row.type), 1)
                      ]))
                    : _createCommentVNode("", true),
                (scope.row.type === '减保')
                  ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                      _hoisted_12,
                      _createTextVNode(" " + _toDisplayString(scope.row.type), 1)
                    ]))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            }),
            _createVNode(_component_el_table_column, {
              prop: "person_count",
              width: "50",
              label: "人数"
            }),
            _createVNode(_component_el_table_column, {
              prop: "start_date",
              label: "生效日期"
            }),
            _createVNode(_component_el_table_column, {
              prop: "create_time",
              label: "录入时间"
            }),
            _createVNode(_component_el_table_column, {
              formatter: _ctx.formatClientUser,
              label: "录入人"
            }, {
              default: _withCtx((scope) => [
                _createElementVNode("div", _hoisted_13, [
                  (scope.row.clientUser?.avatar)
                    ? (_openBlock(), _createElementBlock("img", {
                        key: 0,
                        class: "avatar",
                        src: scope.row.clientUser?.avatar
                      }, null, 8, _hoisted_14))
                    : _createCommentVNode("", true),
                  _createElementVNode("span", null, "   " + _toDisplayString(scope.row.clientUser?.real_name), 1),
                  (scope.row.source === 'mp')
                    ? (_openBlock(), _createElementBlock("img", _hoisted_15))
                    : _createCommentVNode("", true)
                ])
              ]),
              _: 1
            }, 8, ["formatter"]),
            _createVNode(_component_el_table_column, {
              width: "80",
              label: "状态"
            }, {
              default: _withCtx((scope) => [
                _createElementVNode("span", {
                  class: _normalizeClass(
                                    'dot ' +
                                        (scope.row.status === '成功'
                                            ? 'dot-green'
                                            : 'dot-red')
                                )
                }, null, 2),
                _createElementVNode("span", null, _toDisplayString(scope.row.status), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_el_table_column, {
              fixed: "right",
              width: "120",
              label: "操作"
            }, {
              default: _withCtx((scope) => [
                _createElementVNode("span", {
                  class: "link",
                  onClick: ($event: any) => (_ctx.$router.push({ path: '/insurance/order/' + scope.row.order_id }))
                }, " 查看 ", 8, _hoisted_16),
                _hoisted_17,
                _createElementVNode("span", {
                  class: "link",
                  onClick: ($event: any) => (_ctx.onExport(scope.row.order_id))
                }, " 导出 ", 8, _hoisted_18)
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["data"]),
        _createVNode(_component_el_pagination, {
          class: "pagination",
          currentPage: _ctx.pageNum,
          "onUpdate:currentPage": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.pageNum) = $event)),
          "page-size": _ctx.pageSize,
          "onUpdate:page-size": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.pageSize) = $event)),
          "page-sizes": [10, 30, 50, 100],
          total: _ctx.total,
          layout: "total, sizes, prev, pager, next, jumper",
          onSizeChange: _ctx.handleSizeChange,
          onCurrentChange: _ctx.handleCurrentChange
        }, null, 8, ["currentPage", "page-size", "total", "onSizeChange", "onCurrentChange"])
      ])
    ])
  ]))
}